import { Star } from "lucide-react";

interface TestimonialCardProps {
  name: string;
  rating: number;
  text: string;
  location?: string;
}

const TestimonialCard = ({ name, rating, text, location }: TestimonialCardProps) => {
  return (
    <div className="bg-card rounded-2xl p-6 shadow-soft hover:shadow-card transition-shadow duration-300">
      {/* Stars */}
      <div className="flex gap-1 mb-4">
        {Array.from({ length: 5 }).map((_, i) => (
          <Star
            key={i}
            className={`w-5 h-5 ${
              i < rating ? "fill-accent text-accent" : "text-muted"
            }`}
          />
        ))}
      </div>

      {/* Quote */}
      <blockquote className="text-foreground mb-4 leading-relaxed">
        "{text}"
      </blockquote>

      {/* Author */}
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-full bg-primary flex items-center justify-center text-primary-foreground font-semibold">
          {name.charAt(0)}
        </div>
        <div>
          <div className="font-semibold text-foreground">{name}</div>
          {location && (
            <div className="text-sm text-muted-foreground">{location}</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TestimonialCard;
